import { render, staticRenderFns } from "./BadContracts.vue?vue&type=template&id=4e510770&scoped=true"
import script from "./BadContracts.vue?vue&type=script&lang=js"
export * from "./BadContracts.vue?vue&type=script&lang=js"
import style0 from "./BadContracts.vue?vue&type=style&index=0&id=4e510770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e510770",
  null
  
)

export default component.exports